module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/d7886c169fff7250d9d901da0684b86a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_search.svg
// module id = koc0
// module chunks = 0